module.exports = __webpack_public_path__ + "img/icon_items_white.68904c91.png";